import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import RightDrawer from "../../../../../components/WMS/Mobile/RightDrawer";
import WmsMobileLayout from "../../../wmsMobileLayout";
import MobileItem from "../../../../../components/WMS/Mobile/MobileItem";
import ThumbnailAndNotification from "../../../../../components/WMS/Mobile/ThumbnailAndNotification";
import {FormattedMessage} from "react-intl";
import {ArrowRightIcon} from "@mui/x-date-pickers";
import CustomButton from "../../../../../components/CustomButton";
import Badge from "../../../../../components/Badge";
import {Grid} from "@mui/material";
import {SortingContext} from "../SortingContext";
import ToBeSortedSingleTrolley from "./component/ToBeSortedSingleTrolley/ToBeSortedSingleTrolley";
import {BarCodeScannerContext} from "../../../../../contexts/barCodeScannerContext";
import StopSortingPopup from "../StopSortingPopup";
import {ReactComponent as ScanShelf} from "assets/img/wms/scanShelf.svg";
import {ReactComponent as LocationIcon} from "assets/img/wms/location.svg";
import Popup from "../../../../../components/WMS/Mobile/Popup";
import TextEmphasisBloc from "../../../../../components/WMS/TextEmphasisBloc";
import CarrierIcon
    from "../../../packing/components/PackingOrderList/components/Drawers/SelectedItemPackingDrawer/components/CarrierIcon";
import Toast from "../../../../../components/WMS/Toast";
import ValidatedIcon from "../../../../../assets/img/validated.svg";
import {launchOmniScan} from "../../../../../api/wms/omiScan";
import {WMSOmniScanContextKeys} from "../../../../../utils/WMSOmniScanContextKeys";
import {getWMSOmniScanReturnTypeTranslations, WMSOmniScanReturnType} from "../../../../../utils/WMSOmniScanReturnType";
import {WmsContainerType} from "../../../../../utils/WMSContainerType";
import RedWarning from "../../../../../assets/img/redWarning.svg";
import {WMSContext} from "../../../context/WMSContext";
import {wmsItemSort} from "../../../../../api/wms/wmsItems/wmsItems";
import {
    patchWMSContainerMemberWithCodebar,
    patchWmsContainersWithCodebar
} from "../../../../../api/wms/wmsContainers/wmsContainers";
import {getShipmentById} from "../../../../../api/shipment/getWithId";
import FullTransfer from "../../../../../components/WMS/MassTransfert/FullTransfer";
import StackTransfer from "./component/ToBeSortedSingleTrolley/StackTransfer";
import ScanFinishContent from "./component/ToBeSortedSingleTrolley/components/ScanFinishContent";
import DrawerHeaderMenu from "./DrawerHeaderMenu";
import {getTranslation} from "domain/helpers/translations";
import ToBeCancelled from "../../../../../components/WMS/ToBeCancelled";

MerchantList.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
};

function MerchantList({open, handleClose}) {

    const {
        selectedContainer,
        selectedContainerIndex,
        inSorting,
        handleStartSorting,
        refreshTrolley,
        handleFinishSorting,
        massTransferToStack,
        massTransfer,
        setInSorting
    } = useContext(SortingContext)
    const {scannedString, resetScannedString, setEnableScan} = useContext(BarCodeScannerContext)
    const {currentInventory} = useContext(WMSContext)

    const [selectedRetailer, setSelectedRetailer] = useState(null)
    const [orderType, setOrderType] = useState("")
    const [alreadyInUseWmsContainer, setAlreadyInUseWmsContainer] = useState({})
    const [scannedWmsItem, setScannedWmsItem] = useState({})
    const [isMultiFirstItem, setIsMultiFirstItem] = useState(true)
    const [isScanFinish, setIsScanFinish] = useState(false)

    const [openScanModal, setOpenScanModal] = useState(false)
    const [openProductDrawer, setOpenProductDrawer] = useState(false)
    const [openFullHiveModal, setOpenFullHiveModal] = useState(false)
    const [openFullTransferModal, setOpenFullTransferModal] = useState(false)
    const [openInSortingCloseModal, setOpenInSortingCloseModal] = useState(false)
    const [openToBeCancelledModal, setOpenToBeCancelledModal] = useState(false)

    const [openToast, setOpenToast] = useState(false)
    const [toastIcon, setToastIcon] = useState()
    const [toastIconAlt, setToastIconAlt] = useState("")
    const [toastTitle, setToastTitle] = useState()
    const [toastSubtitle, setToastSubtitle] = useState()

    const handleCloseProductDrawer = () => {
        setOpenProductDrawer(false)
        setSelectedRetailer(null)
        if (isScanFinish) {
            handleClose()
        }
    }

    const openProductList = (retailer) => {
        setSelectedRetailer(retailer)
        setOpenProductDrawer(true)
    }

    const handleCloseScanModal = () => {
        setOpenScanModal(false)
        setOrderType("")
        setScannedWmsItem({})
    }

    const handleOpenToast = (container) => {
        if ("multi" === orderType) {
            setToastIcon(createIconToast(ValidatedIcon, "validated-icon"));
            setToastTitle(<FormattedMessage id={"wms.sorting.multi.success.toast.title"}/>)
            setToastSubtitle(
                <Grid container flexDirection={"column"}>
                    <Grid item><FormattedMessage
                        id={"wms.sorting.multi.success.toast.subtitle.hiveName"}/>: {container.hiveName}</Grid>
                    <Grid item><FormattedMessage
                        id={"wms.sorting.multi.success.toast.subtitle.slotName"}/>: {container.name}</Grid>
                </Grid>
            )
        }

        if ("mono" === orderType) {
            setToastIcon(createIconToast(ValidatedIcon, "validated-icon"));
            setToastTitle(<FormattedMessage id={"wms.sorting.mono.success.toast.title"}/>)
            setToastSubtitle(container.name)
        }

        setOpenToast(true)
    }

    const handleCloseToast = () => {
        setToastIcon(null)
        setToastIconAlt(null)
        setToastTitle(null)
        setToastIconAlt(null)
        setOpenToast(false)
    }

    // This might be removed in V2 when we implement multi-hiveContainer sorting.
    const handleOpenWrongContainerToast = (container = null) => {
        setToastIcon(createIconToast(RedWarning, 'red-warning'));
        setToastTitle(<FormattedMessage id={"wms.sorting.toast.wrongContainer.title"}/>)
        if (container) {
            setToastSubtitle(<><FormattedMessage id={"wms.sorting.toast.wrongContainer.subtitle"}/>: {container.hiveName} • {container.name}</>)
        }
        setOpenToast(true)
        setEnableScan(true)
    }

    const handleScanningContainer = () => {
        // If its a multi and an article is already in a sorting container
        if (0 < Object.keys(alreadyInUseWmsContainer).length) {

            if (openFullHiveModal && scannedString === alreadyInUseWmsContainer.codebar) {
                handleFullContainerScan(alreadyInUseWmsContainer)
                return
            }

            launchOmniScan(scannedString, currentInventory.id, {[WMSOmniScanContextKeys.CONTAINER]: ["hive"]}).then((response) => {
                if (response.length === 1 && WMSOmniScanReturnType.CONTAINER === response[0].entityType) {
                    if (scannedString === alreadyInUseWmsContainer.codebar || openFullHiveModal) {
                        handleSortItem(response[0])
                    } else if (!openFullHiveModal) {
                        handleOpenWrongContainerToast(alreadyInUseWmsContainer)
                    }
                } else {
                    if (response.length === 1) {
                        handleWrongEntityType(response)
                    }
                    if (response.length === 0) {
                        handleOmniScanNotFound()
                    }
                }
                resetScannedString()
            })

        } else {
            // If there is no container already associated with the order it is either a multi item order, and we scanned the first item, or a mono item order.
            launchOmniScan(scannedString, currentInventory.id, {[WMSOmniScanContextKeys.CONTAINER]: ["hive", "shelf"]}).then((response) => {
                if (response.length === 1 && WMSOmniScanReturnType.CONTAINER === response[0].entityType) {
                    if (WmsContainerType.HIVE === response[0].type || WmsContainerType.SHELF === response[0].type) {
                        if ('multi' === orderType) {
                            if (WmsContainerType.HIVE === response[0].type) {
                                if (response[0].maxCapacity) {
                                    handleFullContainerScan(response[0])
                                    return
                                }

                                if (response[0].hasItems) {
                                    handleAlreadyUsedHive()
                                    return
                                }

                                handleSortItem(response[0])
                            } else {
                                handleOpenWrongContainerToast()
                            }
                        } else {
                            if (WmsContainerType.HIVE === response[0].type && response[0].hasItems) {
                                handleAlreadyUsedHive()
                                return
                            }

                            handleSortItem(response[0])
                        }
                    } else {
                        handleOpenWrongContainerToast()
                    }
                } else {
                    if (response.length === 1) {
                        handleWrongEntityType(response)
                    }
                    if (response.length === 0) {
                        handleOmniScanNotFound()
                    }
                }
                resetScannedString()
            })
        }
    }

    const handleScanningArticle = async () => {
        let matchedItem = null
        for (let item of selectedContainer.wmsItems) {
            const barcode = item.barcode ?? item.lineItem.variation.barcode
            if (!barcode || scannedString !== barcode) {
                continue
            }
            matchedItem = item
        }

        if (null === matchedItem) {
            setEnableScan(true)
            handleOmniScanNotFound()
            return;
        }

        await handleArticleSelected(matchedItem)
    }

    const handleSortItem = (destinationContainer) => {
        wmsItemSort(scannedWmsItem.id, destinationContainer.codebar).then((response) => {
            if (response.ok) {
                refreshTrolley([scannedWmsItem])
            }

            handleOpenToast(destinationContainer)

            if (openFullHiveModal) {
                patchWmsContainersWithCodebar(alreadyInUseWmsContainer.codebar, {maxCapacity: true}).then(r => {
                    handleCloseFullHiveModal()
                })
            } else {
                handleCloseScanModal()
            }
            setOrderType("")
            setAlreadyInUseWmsContainer({})
        }).catch(() => {
            handleSortItemError()
        })
    }

    const handleFullHive = () => {
        setOpenScanModal(false)
        setOpenFullHiveModal(true)
    }

    const handleCloseFullHiveModal = () => {
        setOpenFullHiveModal(false)
        setOrderType("")
        setScannedWmsItem({})
    }

    const handleFullContainerScan = (container = null) => {
        setToastIcon(createIconToast(RedWarning, "error"))
        setToastTitle(<FormattedMessage id={"wms.sorting.toast.fullHiveScan.title"}/>)

        if (container) {
            setToastSubtitle(<FormattedMessage id={"wms.sorting.toast.fullHiveScan.subtitle"}
                                               values={{hiveName: container.hiveName + " • " + container.name}}/>)
        }

        setOpenToast(true)
        setEnableScan(true)
    }

    const handleCloseFullTransferModal = (doRefresh) => {
        if (doRefresh) {
            refreshTrolley(selectedContainer.wmsItems)
        }
    }

    const handleWrongEntityType = (response) => {
        const scannedType = <FormattedMessage id={getWMSOmniScanReturnTypeTranslations(response[0].entityType)}/>
        setToastTitle(<FormattedMessage id={'wms.sorting.toast.wrongBarcodeScanned.title'}/>)
        setToastSubtitle(
            <FormattedMessage
                id={'wms.sorting.toast.wrongBarcodeScanned.subtitle'}
                values={{scannedType: scannedType}}/>
        )
        setToastIcon(createIconToast(RedWarning, 'red-warning'));
        setToastIconAlt(createIconToast('red-warning'));
        setOpenToast(true)
        setEnableScan(true)

    }

    const handleAlreadyUsedHive = () => {
        setToastIcon(createIconToast(RedWarning, "error"))
        setToastTitle(<FormattedMessage id={"wms.sorting.toast.alreadyUsedHiveScan.title"}/>)
        setToastSubtitle(<FormattedMessage id={"wms.sorting.toast.alreadyUsedHiveScan.subtitle"}/>)

        setOpenToast(true)
        setEnableScan(true)
    }

    const handleOmniScanNotFound = () => {
        setToastIcon(createIconToast(RedWarning, 'red-warning'))
        setToastTitle(<FormattedMessage id={"wms.omniScan.notFound"}/>)
        setOpenToast(true)
        setEnableScan(true)
    }

    const handleSortItemError = () => {
        setToastIcon(createIconToast(RedWarning, 'red-warning'))
        setToastTitle(<FormattedMessage id={"wms.sorting.toast.sortItemError.title"}/>)
        setToastSubtitle(<FormattedMessage id={"wms.sorting.toast.sortItemError.subtitle"}/>)
        setOpenToast(true)
        setEnableScan(true)
    }

    const handleCloseInSortingModal = () => {
        setOpenInSortingCloseModal(false)
    }

    const handleCloseToBeCancelledModal = (itemIsCancelled = false) => {
        if (itemIsCancelled) {
            refreshTrolley([scannedWmsItem])
        } else {
            setScannedWmsItem({})
            resetScannedString()
            setEnableScan(true)
        }
        setOpenToBeCancelledModal(false)
    }

    const handleArticleSelected = async (item) => {
        setScannedWmsItem(item)

        if (item.toBeCancelled) {
            setOpenToBeCancelledModal(true)
            return
        }

        const isMultiShipment = item.lineItem.currentShipment.multi
        if (isMultiShipment) {
            const wmsContainer = await haveAlreadyUsedContainer(item)
            if (false === wmsContainer) {
                setEnableScan(true)
                return
            }

            setOrderType('multi');

            // if wmscontainer object
            if (!Array.isArray(wmsContainer) && wmsContainer.id) {
                setAlreadyInUseWmsContainer(wmsContainer)
                setIsMultiFirstItem(false)
            }
        } else {
            setOrderType("mono")
        }
    }

    const haveAlreadyUsedContainer = (item) => {
        return getShipmentById(item.lineItem.currentShipment.id).then((response) => {
            let lineItems = response.lineItems
            let shipmentContainers = lineItems.filter((lineItem) => WmsContainerType.HIVE === lineItem.wmsItem?.wmsContainer?.type)

            if (0 === shipmentContainers.length) {
                return [];
            }

            if (1 < shipmentContainers.length) {
                shipmentContainers = shipmentContainers.filter((lineItem) => false === lineItem.wmsItem.wmsContainer?.maxCapacity)
            }


            return shipmentContainers[0].wmsItem.wmsContainer
        }).catch(() => {
            return false
        })
    }

    const getRetailersFromContainer = (container) => {
        const retailerMap = {}

        container.wmsItems.forEach(item => {
            const id = item.retailer?.id

            if (!id) {
                return
            }

            if (!retailerMap[id]) {
                retailerMap[id] = {
                    id,
                    name: item.retailer.name,
                    logo: getTranslation(item.retailer)?.logo?.contentUrl ?? null,
                    count: 0,
                }
            }
            retailerMap[id].count++
        })
        return Object.values(retailerMap)
    }

    function getScanPopupTitle() {
        if (openFullHiveModal) {
            return <FormattedMessage id={"wms.sorting.scan.fullHiveModal.title"}/>
        }

        if (orderType === "mono") {
            return <FormattedMessage id={"wms.sorting.scan.monoOrder.title"}/>
        }

        if (orderType === "multi") {
            return <FormattedMessage id={"wms.sorting.scan.multiOrder.title"}/>
        }

    }

    function getScanPopupSubtitle() {
        if (openFullHiveModal) {
            return <FormattedMessage id={"wms.sorting.scan.fullHiveModal.subtitle"}
                                     values={{hiveName: "" + alreadyInUseWmsContainer.hiveName + " • " + alreadyInUseWmsContainer.name}}/>
        }

        if (orderType === "mono") {
            return <FormattedMessage id={"wms.sorting.scan.monoOrder.subtitle"}/>;
        }

        if (orderType === "multi") {
            if (isMultiFirstItem) {
                return <FormattedMessage id={"wms.sorting.scan.multiOrder.firstItem.subtitle"}/>;
            }

            return <FormattedMessage id={"wms.sorting.scan.multiOrder.subtitle"}/>;
        }
    }

    function getScanPopupIcon() {
        if (orderType === "mono") {
            return <LocationIcon/>;
        }

        if (orderType === "multi") {
            return <ScanShelf/>;
        }
    }

    function createIconToast(icon, alt) {
        return (
            <img
                src={icon}
                alt={alt}
                style={{
                    width: '20px',
                    height: '20px',
                }}
            />
        )
    }

    async function removeMemberFromTrolley(containerBarcode) {
        return patchWMSContainerMemberWithCodebar(containerBarcode, null);
    }

    const goBackToSorting = () => {
        setScannedWmsItem({})
        handleFinishSorting()
    }

    // TO OPEN THE SCAN MODAL
    useEffect(() => {
        if ("" !== orderType) {
            setOpenScanModal(true)
            setEnableScan(true)
        }
    }, [orderType]);

    useEffect(() => {
        if (selectedContainer && false === openScanModal && 0 === selectedContainer.wmsItems.length) {
            removeMemberFromTrolley(selectedContainer.codebar).then(() => {
                setIsScanFinish(true)
                setOpenFullTransferModal(false)
                setInSorting(false)
            }).catch(() => {
                setEnableScan(true)
            })
        } else {
            setIsScanFinish(false)
        }

        if (selectedContainer && false === openScanModal && 0 <= selectedContainer.wmsItems.length) {
            setScannedWmsItem({})
            setEnableScan(true)
        }
    }, [selectedContainer]);

    useEffect(() => {
        if (!openFullTransferModal && inSorting && scannedWmsItem && 0 < scannedString.length) {
            setEnableScan(false)
            // WHEN SCANNING AN ARTICLE
            if (0 === Object.keys(scannedWmsItem).length) {
                handleScanningArticle()
            }

            // WHEN SCANNING A CONTAINER
            if ((true === openScanModal || true === openFullHiveModal) && 0 < Object.keys(scannedWmsItem).length) {
                handleScanningContainer()
            }
        }
    }, [scannedString]);

    return (
        <>
            <ToBeSortedSingleTrolley
                open={openProductDrawer}
                setOpen={setOpenProductDrawer}
                handleClose={handleCloseProductDrawer}
                selectedRetailer={selectedRetailer}
                isScanFinish={isScanFinish}
                handleArticleSelected={handleArticleSelected}
                handleCloseFullTransferModal={handleCloseFullTransferModal}
                goBackToSorting={goBackToSorting}
            />

            {openToBeCancelledModal && scannedWmsItem && (
                <ToBeCancelled
                    open={openToBeCancelledModal}
                    item={scannedWmsItem}
                    handleClose={handleCloseToBeCancelledModal}
                />
            )}

            {openInSortingCloseModal && (
                <StopSortingPopup
                    open={openInSortingCloseModal}
                    onConfirm={() => removeMemberFromTrolley(selectedContainer.codebar).then(() => goBackToSorting())}
                    onCancel={handleCloseInSortingModal}
                />
            )}

            {openScanModal && (
                <Popup
                    open={openScanModal}
                    onClose={handleCloseScanModal}
                    title={getScanPopupTitle()}
                    subtitle={getScanPopupSubtitle()}
                    icon={getScanPopupIcon()}
                >
                    <Grid container direction={"column"} justifyContent={"space-between"}
                          alignContent={"center"} alignItems={"center"}>
                        {orderType === "multi" && 0 < Object.keys(alreadyInUseWmsContainer).length && (
                            <Grid container direction={'column'} justifyContent={'space-between'}>
                                <TextEmphasisBloc
                                    leftPart={<>{alreadyInUseWmsContainer.hiveName ?? <></>} • {alreadyInUseWmsContainer.name}</>}/>
                                <CustomButton fullWidth onClick={handleFullHive}>
                                    <FormattedMessage id={"wms.sorting.scan.multiOrder.full"}/>
                                </CustomButton>
                            </Grid>
                        )}
                        {scannedWmsItem.lineItem.currentShipment?.shippingMethod && (
                            <Grid item sx={{marginTop: "8px"}}>
                                <Badge rounded size={'xl'} color={'info'}>
                                    <Grid container gap={'8px'}>
                                        <CarrierIcon
                                            shippingMethod={scannedWmsItem.lineItem.currentShipment.shippingMethod}/>
                                        {scannedWmsItem.lineItem.currentShipment.shippingMethod?.name}
                                    </Grid>
                                </Badge>
                            </Grid>
                        )}
                    </Grid>
                </Popup>
            )}

            {openFullHiveModal && (
                <Popup
                    open={openFullHiveModal}
                    onClose={handleCloseFullHiveModal}
                    title={getScanPopupTitle()}
                    subtitle={getScanPopupSubtitle()}
                    icon={getScanPopupIcon()}
                />
            )}

            {openToast && (
                <Toast
                    icon={toastIcon}
                    title={toastTitle}
                    subtitle={toastSubtitle}
                    open={openToast}
                    handleClose={handleCloseToast}
                    disablePortal={false}
                />
            )}

            {isScanFinish &&
                <Badge
                    label={<FormattedMessage id={"wms.sorting.scan.scanIsFinished.label"}/>}
                    color={"online"}
                    rounded
                    isBold={false}
                    size={"large"}
                />
            }

            <RightDrawer
                open={open}
                handleClose={handleClose}
                strictOnClose={isScanFinish}
                headerLeftContent={
                    <b style={{marginLeft: '16px', fontSize: '16px'}}>
                        {selectedContainer?.name ?? selectedContainerIndex}
                    </b>
                }
                headerRightContent={
                    <DrawerHeaderMenu
                        itemCount={selectedContainer?.wmsItems.length}
                        additionalMenu={
                            <Grid
                                container
                                onClick={() => openProductList(null)}
                            >
                                <FormattedMessage id={"wms.sorting.seeFullItemList"}/>
                            </Grid>
                        }
                    />
                }
            >
                {isScanFinish ? (
                    <ScanFinishContent goBackToSorting={() => goBackToSorting()}/>
                ) : (
                    <WmsMobileLayout disableMargin fitParent>
                        <WmsMobileLayout.Content>
                            {getRetailersFromContainer(selectedContainer).map(retailer => {
                                return (
                                    <MobileItem key={retailer.id} onClick={() => openProductList(retailer)}>
                                        <MobileItem.LeftSide
                                            title={
                                                <Grid
                                                    container
                                                    flexWrap={'nowrap'}
                                                    gap={'8px'}
                                                >
                                                    {retailer.name}
                                                    <Badge
                                                        color={retailer.count === 0 ? 'online' : 'warning'}
                                                        rounded
                                                        isBold={false}
                                                        size={'large'}
                                                    >
                                                        {retailer.count} <FormattedMessage id={"wms.sorting.article"}/>
                                                    </Badge>
                                                </Grid>
                                            }
                                        >
                                            <ThumbnailAndNotification link={retailer.logo ?? ""} validated={false}/>
                                        </MobileItem.LeftSide>
                                        <MobileItem.RightSide>
                                            <ArrowRightIcon/>
                                        </MobileItem.RightSide>
                                    </MobileItem>
                                )
                            })}
                        </WmsMobileLayout.Content>
                        <WmsMobileLayout.Footer>
                            <Grid container flexWrap={'nowrap'}>
                                {isScanFinish === false && massTransfer && inSorting && (
                                    <FullTransfer
                                        handleIsValid={(doRefresh) => handleCloseFullTransferModal(doRefresh)}
                                        currentContainer={selectedContainer}
                                        inSorting={inSorting}
                                        toContainers={[
                                            WmsContainerType.SHELF
                                        ]}
                                    />
                                )}
                                {isScanFinish === false && massTransferToStack && inSorting && selectedContainer && selectedContainer.type !== WmsContainerType.STACK && (
                                    <StackTransfer
                                        currentContainer={selectedContainer}
                                        handleIsValid={(doRefresh) => handleCloseFullTransferModal(doRefresh)}
                                        fullWidth={!massTransfer}
                                        onPopupOpenChange={(isOpen) => setEnableScan(!isOpen)}
                                    />
                                )}
                                {!inSorting && (
                                    <CustomButton
                                        onClick={() => handleStartSorting()}
                                        fullWidth
                                    >
                                        <FormattedMessage id={"wms.sorting.containerPeek.button"} values={{containerName: selectedContainer.name ?? selectedContainerIndex}}/>
                                    </CustomButton>
                                )}
                            </Grid>
                        </WmsMobileLayout.Footer>
                    </WmsMobileLayout>
                )}

            </RightDrawer>
        </>

    );
}

export default MerchantList;